<button class="btn btn-primary mb-1" [disabled]="!isEnabled || isBlocked" (click)="generateTicket()" #button>
    <span class="element-text">{{ 'console.generate-ticket' | translate }}</span>
</button>